<script>
  export let fields = {}

  let width
</script>

<svelte:window bind:innerWidth={width} />

<div class="consultus__image">
  <img
    src={fields.image}
    alt={fields.alt ?? 'Image over Image'}
    class="consultus__image__main"
    style:aspect-ratio={fields.xRatio && fields.yRatio ? fields.xRatio / fields.yRatio : 'auto'}
    optimise="true"
  />

  {#if fields.overlay}
    <img
      src={fields.overlay}
      alt="Image overlay"
      class="consultus__image__desktop"
      optimise="true"
      style="{width && (width < 1000 && fields.overlayMobile) ? 'display: none;' : ''}"
    />
  {/if}

  {#if fields.overlayMobile}
    <img
      src={fields.overlayMobile}
      alt="Image overlay"
      class="consultus__image__mobile"
      optimise="true"
      style="{width && (width < 1000 && fields.overlayMobile) ? 'display: block;' : ''}"
    />
  {/if}
</div>

<style lang="scss">.consultus__image {
  position: relative;
  overflow: hidden;
}

.consultus__image__main {
  object-fit: cover;
  width: 100%;
  max-height: 100%;
}

.consultus__image__desktop {
  max-width: none;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  object-fit: cover;
  display: block;
}

.consultus__image__mobile {
  max-width: none;
  width: calc(100% + 2px);
  position: absolute;
  bottom: -1px;
  left: -1px;
  right: -1px;
  object-fit: cover;
  display: none;
}

@media screen and (max-width: 1000px) {
  .consultus__image:has(.consultus__image__mobile) .consultus__image__desktop {
    display: none;
  }
  .consultus__image:has(.consultus__image__mobile) .consultus__image__mobile {
    display: block;
  }
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>